import Bugsnag from "@bugsnag/js";
import axios from "axios";
import React, { Component } from "react";
import SEO from "react-seo-component";
import {
  Button,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import PlacesAutocomplete from "../../components/common/PlacesAutocomplete";
import constants from "../../Constants";
import util from "../../util";

const baseURL = constants.baseURL;
class Section extends Component {
  constructor() {
    super();
    // let directUserToQuote = "";
    // try {
    //   const queryParams = new URLSearchParams(window.location.search);
    //   directUserToQuote = queryParams.get("dutq") || "";
    //   // if (!directUserToQuote || directUserToQuote.length === 0)
    //     // window.location.href = "/quote";
    // } catch (error) {
    //   Bugsnag.notify(error);
    // }
    this.state = {
      loading: false,
      openSuccessModal: false,
      truckType: "",
      apierror: "",
      location: {
        lat: 0,
        lng: 0,
      },
      firstname: "",
      lastname: "",
      email: "",
      mobilenumber: "",
      idnumber: "",
      vin: "",
      licenseplatenumber: "",
      vehicles: 0,
      vehicletypes: [],
      uniqueTonnages: [],
      nonCargoGroups: [],
      // Vehicle Picker Wizard
      selectedVehicleCategory: null,
      // Checkboxes
      agreeToPartner: false,
      agreeToNotifications: false,
    };

    // Vehicle category mappings for the wizard
    this.vehicleCategories = [
      {
        id: "bakkie",
        label: "Bakkie or Minivan",
        icon: "mdi-truck",
        description: "Small pickup vehicles and minivans",
        tonnageRange: [0.5, 0.8, 1, 1.5],
        isPassenger: false,
        backgroundImage: "https://media.qiktruck.co.za/1tonopen.png",
      },
      {
        id: "small-truck",
        label: "Small Truck",
        icon: "mdi-truck-delivery",
        description: "1.5 to 4 ton trucks",
        tonnageRange: [1.5, 2, 3, 4],
        isPassenger: false,
        backgroundImage: "https://media.qiktruck.co.za/1.5tonopen.png",
      },
      {
        id: "big-truck",
        label: "Big Truck",
        icon: "mdi-tanker-truck",
        description: "6 ton and above",
        tonnageRange: [6, 8, 10, 12, 14, 16, 20, 30, 34],
        isPassenger: false,
        backgroundImage: "https://media.qiktruck.co.za/8tonopen.png",
      },
      {
        id: "bike",
        label: "Bike",
        icon: "mdi-bike",
        description: "Motorcycles & scooters",
        tonnageRange: [0.02, 0.05],
        isPassenger: false,
        backgroundImage: "https://media.qiktruck.co.za/motorbike.png",
      },
      {
        id: "tow-truck",
        label: "Tow Truck",
        icon: "mdi-car-traction-control",
        description: "Vehicle recovery & transport",
        tonnageRange: [],
        isPassenger: false,
        loadgroups: ["Tow Truck"],
        backgroundImage: "https://media.qiktruck.co.za/towtruck4ton.png",
      },
      {
        id: "sedan",
        label: "Sedan",
        icon: "mdi-car",
        description: "4-door passenger cars",
        tonnageRange: [],
        isPassenger: true,
        loadgroups: ["Sedan"],
        backgroundImage: "https://media.qiktruck.co.za/sedan.png",
      },
      {
        id: "hatchback",
        label: "Hatchback",
        icon: "mdi-car-sports",
        description: "Compact cars with rear door",
        tonnageRange: [],
        isPassenger: true,
        loadgroups: ["Hatchback"],
        backgroundImage: "https://media.qiktruck.co.za/hatchback.png",
      },
      {
        id: "passenger",
        label: "SUV & Minibus",
        icon: "mdi-van-passenger",
        description: "SUVs, minibuses & safari vehicles",
        tonnageRange: [],
        isPassenger: true,
        loadgroups: ["6+ People", "Safari Experience"],
        backgroundImage: "https://media.qiktruck.co.za/safari8.png",
      },
    ];
    // this.registrationform = React.createRef();
    // this.vehiclepicker = React.createRef();
  }
  componentDidMount() {
    axios
      .get(baseURL + "/vehicle-types")
      .then((repos) => {
        const vehicletypesdata = repos.data;
        const allVehicles = vehicletypesdata?.vehicles || [];
        const cargoVehicles = allVehicles.filter(
          (v) => v.display === true && Number(v.tonnes) > 0
        );
        const nonCargoVehicles = allVehicles.filter(
          (v) => v.display === true && Number(v.tonnes) === 0
        );
        const uniqueTonnages = [
          ...new Set(cargoVehicles.map((v) => v.tonnes)),
        ].sort((a, b) => a - b);

        // Group all vehicles by loadgroup (for loadgroup-based filtering like Tow Trucks)
        const allGroupsMap = {};
        allVehicles.filter(v => v.display === true).forEach((v) => {
          const key = v.loadgroup || "Other";
          if (!allGroupsMap[key]) allGroupsMap[key] = [];
          allGroupsMap[key].push(v);
        });

        // Non-cargo groups (tonnes === 0)
        const nonCargoGroupsMap = {};
        nonCargoVehicles.forEach((v) => {
          const key = v.loadgroup || "Other";
          if (!nonCargoGroupsMap[key]) nonCargoGroupsMap[key] = [];
          nonCargoGroupsMap[key].push(v);
        });
        
        // Merge all loadgroups (includes tow trucks and passenger vehicles)
        const nonCargoGroups = Object.keys(allGroupsMap).map((group) => ({
          group,
          vehicles: allGroupsMap[group],
        }));

        this.setState({
          vehicletypes: cargoVehicles,
          uniqueTonnages,
          nonCargoGroups,
        });
      })
      .catch((e) => {
        this.setState({ apierror: "Failed to load vehicle types" });
        Bugsnag.notify(e);
      });
  }
  validStepOne() {
    const {
      truckType,
      location,
      firstname,
      lastname,
      email,
      mobilenumber,
      idnumber,
      licenseplatenumber,
    } = this.state;
    if (
      truckType === "" ||
      firstname?.length < 2 ||
      lastname?.length < 1 ||
      email?.length < 5 ||
      mobilenumber?.length < 8 ||
      idnumber?.length < 5 ||
      licenseplatenumber?.length < 5 ||
      truckType === ""
    )
      return false;
    if (location.lat === 0) return false;
    return true;
  }

  registerVehicle() {
    const {
      truckType,
      location,
      firstname,
      lastname,
      email,
      mobilenumber,
      idnumber,
      licenseplatenumber,
    } = this.state;
    this.setState({ loading: true, apierror: "" });
    axios
      .post(baseURL + "/register-vehicle", {
        truckType,
        location,
        firstname,
        lastname,
        email,
        mobilenumber,
        idnumber,
        licenseplatenumber,
        source_:
          util.navigator_() + util.source_() + " qtref:" + document?.referrer,
      })
      .then((response) => {
        if (response.data.vehicles > 0) {
          this.setState({
            loading: false,
            vehicles: response.data.vehicles,
            openSuccessModal: true,
          });
        }
      })
      .catch((e) => {
        this.setState({ loading: false, apierror: e.message });
        Bugsnag.notify(e);
      });
  }

  render() {
    const { vehicletypes } = this.state;
    return (
      <React.Fragment>
        <SEO
          title={
            "On demand truck and driver hire transportation service. Local truck/bakkie hire and movers at affordable prices."
          }
          titleTemplate={"QikTruck"}
          titleSeparator={`-`}
          description={
            "Move your goods with our delivery vehicles and drivers. Furniture, Equipment, Construction Materials and more! Review your instant online quotation now. On demand truck and driver hire transportation service."
          }
          image={"https://media.qiktruck.co.za/partner-driver.jpeg"}
          pathname={"https://qiktruck.co.za/partner-drivers"}
          twitterUsername={"qiktrucksa"}
        />
        <section className="hero-section" id="location">
          <Modal isOpen={this.state.openSuccessModal}>
            <ModalHeader>
              <i className={"mdi mdi-check-circle order-received"}></i>
              Vehicle registered successfully
            </ModalHeader>
            <ModalBody>
              <ListGroup className="black-text">
                <ListGroupItem>
                  <i className={"mdi mdi-email order-received-list"}></i>
                  Check your email for your account information.
                </ListGroupItem>

                <ListGroupItem>
                  <i
                    className={"mdi mdi-cash-multiple order-received-list"}
                  ></i>
                  Follow the instructions in the email.
                </ListGroupItem>
                <ListGroupItem>
                  <i className={"mdi mdi-check-circle order-received-list"}></i>
                  Download the driver mobile app!
                </ListGroupItem>
                <ListGroupItem>
                  <i className={"mdi mdi-check-circle order-received-list"}></i>
                  Reviews and inspections take about 20 business days.
                </ListGroupItem>
                <ListGroupItem>
                  <i className={"mdi mdi-check-circle order-received-list"}></i>
                  Share and talk about QikTruck with your network!
                </ListGroupItem>
                <ListGroupItem>
                  <i className={"mdi mdi-check-circle order-received-list"}></i>
                  Happy moving!
                </ListGroupItem>
              </ListGroup>
            </ModalBody>
            <ModalFooter>
              <Button
                color="primary"
                onClick={() =>
                  this.setState(
                    {
                      openSuccessModal: false,
                      trackYourOrder: true,
                    },
                    () => {
                      window.location.href = "https://driver.qiktruck.co.za";
                    }
                  )
                }
              >
                Okay
              </Button>
            </ModalFooter>
          </Modal>
          <Container>
            <h3 className="text-uppercase" id={"vehiclepicker"}>
              Vehicle registration for jobs
            </h3>
            <br/>
            <Row className="mb-4">
              <Col lg={12}>
                <img
                  src={"https://media.qiktruck.co.za/partner-driver.jpeg"}
                  alt={"QikTruck partner drivers banner"}
                  className="img-fluid w-100"
                  style={{
                    borderRadius: 12,
                    height: 180,
                    objectFit: "cover",
                    width: "100%",
                  }}
                />
              </Col>
            </Row>

            <Row className="align-items-stretch mb-3">
              <Col lg={6} md={12}>
                <div
                  className="card shadow-sm mb-4"
                  style={{ borderRadius: 12 }}
                >
                  <div className="card-body">
                    <h6 className="text-uppercase text-muted mb-3">Benefits</h6>
                    <div className="d-flex align-items-start py-2">
                      <span
                        className="mr-2 d-inline-flex align-items-center justify-content-center"
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: 14,
                          background: "#fff1f0",
                          color: "green",
                        }}
                      >
                        <i className="mdi mdi-check-bold"></i>
                      </span>
                      <span>Registration is free.</span>
                    </div>
                    <div className="d-flex align-items-start py-2">
                      <span
                        className="mr-2 d-inline-flex align-items-center justify-content-center"
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: 14,
                          background: "#fff1f0",
                          color: "green",
                        }}
                      >
                        <i className="mdi mdi-check-bold"></i>
                      </span>
                      <span>
                        Commission 13% - 25% (incl. VAT) depending on vehicle
                        size and contract.
                      </span>
                    </div>
                    <div className="d-flex align-items-start py-2">
                      <span
                        className="mr-2 d-inline-flex align-items-center justify-content-center"
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: 14,
                          background: "#fff1f0",
                          color: "green",
                        }}
                      >
                        <i className="mdi mdi-check-bold"></i>
                      </span>
                      <span>Short and long term contracts.</span>
                    </div>
                    <div className="d-flex align-items-start py-2">
                      <span
                        className="mr-2 d-inline-flex align-items-center justify-content-center"
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: 14,
                          background: "#fff1f0",
                          color: "green",
                        }}
                      >
                        <i className="mdi mdi-check-bold"></i>
                      </span>
                      <span>Local and long distance trips.</span>
                    </div>
                    <div className="d-flex align-items-center pt-2">
                      <span className="mr-2">
                        <i className={"mdi mdi-star orange mr-1"}></i>
                        <i className={"mdi mdi-star orange mr-1"}></i>
                        <i className={"mdi mdi-star orange mr-1"}></i>
                        <i className={"mdi mdi-star orange mr-1"}></i>
                        <i className={"mdi mdi-star orange mr-1"}></i>
                      </span>
                      <span>Rated service.</span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={6} md={12}>
                <div
                  className="card shadow-sm mb-4"
                  style={{ borderRadius: 12 }}
                >
                  <div className="card-body">
                    <h6 className="text-uppercase text-muted mb-3">Steps</h6>
                    <div className="d-flex align-items-center py-2">
                      <span
                        className="mr-3 d-inline-flex align-items-center justify-content-center"
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: 14,
                          background: "#fff1f0",
                          color: "green",
                          fontWeight: 600,
                        }}
                      >
                        1
                      </span>
                      <span>Register your vehicle below</span>
                    </div>
                    <div className="d-flex align-items-center py-2">
                      <span
                        className="mr-3 d-inline-flex align-items-center justify-content-center"
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: 14,
                          background: "#fff1f0",
                          color: "green",
                          fontWeight: 600,
                        }}
                      >
                        2
                      </span>
                      <span>Upload documents via the QikTruck Driver app</span>
                    </div>
                    <div className="d-flex align-items-center py-2">
                      <span
                        className="mr-3 d-inline-flex align-items-center justify-content-center"
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: 14,
                          background: "#fff1f0",
                          color: "green",
                          fontWeight: 600,
                        }}
                      >
                        3
                      </span>
                      <span>Application processing</span>
                    </div>
                    <div className="d-flex align-items-center py-2">
                      <span
                        className="mr-3 d-inline-flex align-items-center justify-content-center"
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: 14,
                          background: "#fff1f0",
                          color: "green",
                          fontWeight: 600,
                        }}
                      >
                        4
                      </span>
                      <span>Driver training and certification free</span>
                    </div>
                    <div className="d-flex align-items-center py-2">
                      <span
                        className="mr-3 d-inline-flex align-items-center justify-content-center"
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: 14,
                          background: "#fff1f0",
                          color: "green",
                          fontWeight: 600,
                        }}
                      >
                        5
                      </span>
                      <span>Customer allocation per vehicle location</span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col lg={12} className="d-flex flex-column align-items-center">
                <h5 className="text-muted mb-3">Get the QikTruck Driver app</h5>
                <div className="download-buttons mb-2">
                  <a
                    href="https://play.google.com/store/apps/details?id=za.co.qiktruck.driver"
                    className="download-btn mr-3 mb-3 d-inline-block"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                      alt="Get the QikTruck Driver app on Google Play"
                      className="download-badge"
                      style={{ height: 44 }}
                    />
                  </a>
                  <a
                    href="https://apps.apple.com/za/app/qiktruck-drive-earn/id6480389208"
                    className="download-btn mb-3 d-inline-block"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://qiktruck.co.za/static/media/apple-play-download.3f9ab08ae56699b0acdd1f3adb635d19.svg"
                      alt="Get the QikTruck Driver app on the App Store"
                      className="download-badge"
                      style={{ height: 44 }}
                    />
                  </a>
                </div>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col
                lg={12}
                className="d-flex justify-content-between align-items-center p-3"
                style={{
                  background: "linear-gradient(90deg, #fff7f6, #ffffff)",
                  borderRadius: 12,
                }}
              >
                <div >
                  <h2 className="mb-1">Ready to start?</h2>
                  <p className="mb-0 text-muted">
                    Pick your vehicle and complete your profile to get jobs.
                  </p>
                </div>
                <Button
                  color="primary"
                  onClick={() =>
                    window.document
                      .getElementById("vehiclewizard")
                      ?.scrollIntoView({ behavior: "smooth" })
                  }
                >
                  Start registration
                  <i className="mdi mdi-arrow-right ml-2"></i>
                </Button>
              </Col>
            </Row>

            {/* Vehicle Picker Wizard */}
            <Row className="mb-4">
              <Col lg={12}>
                <div className="text-center mb-4">
                  <h3 id="vehiclewizard" className="mb-2" style={{ fontSize: "2rem", fontWeight: 700 }}>
                    What do you drive?
                  </h3>
                  <p className="text-muted" style={{ fontSize: "1.1rem" }}>
                    Select your vehicle type to see available options
                  </p>
                </div>
                <div 
                  className="d-flex flex-wrap justify-content-center" 
                  style={{ gap: "20px" }}
                >
                  {this.vehicleCategories.map((category) => {
                    const isSelected = this.state.selectedVehicleCategory === category.id;
                    return (
                      <div
                        key={category.id}
                        onClick={() =>
                          this.setState(
                            {
                              selectedVehicleCategory: category.id,
                              truckType: "",
                            },
                            () => {
                              window.document
                                .getElementById("vehiclesizes")
                                ?.scrollIntoView({ behavior: "smooth" });
                            }
                          )
                        }
                        className="vehicle-category-card"
                        style={{
                          cursor: "pointer",
                          position: "relative",
                          overflow: "hidden",
                          borderRadius: 20,
                          minWidth: 180,
                          maxWidth: 220,
                          flex: "1 1 180px",
                          height: 260,
                          border: isSelected
                            ? "3px solid #FF8C00"
                            : "2px solid #e8e8e8",
                          boxShadow: isSelected
                            ? "0 8px 24px rgba(255, 140, 0, 0.35)"
                            : "0 4px 16px rgba(0,0,0,0.08)",
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                          transform: isSelected ? "translateY(-4px)" : "translateY(0)",
                          background: "#fff",
                        }}
                      >
                        {/* Top section with text - solid background */}
                        <div
                          style={{
                            position: "relative",
                            zIndex: 2,
                            background: isSelected
                              ? "linear-gradient(135deg, #fff5e6 0%, #ffe8cc 100%)"
                              : "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
                            padding: "20px 16px 15px",
                            borderBottom: isSelected ? "2px solid #ffcc80" : "1px solid #eee",
                          }}
                        >
                          <div className="text-center">
                            <div
                              style={{
                                width: 50,
                                height: 50,
                                borderRadius: "50%",
                                background: isSelected
                                  ? "linear-gradient(135deg, #FF8C00, #FFA500)"
                                  : "linear-gradient(135deg, #4f6367, #6b8589)",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: 10,
                                boxShadow: isSelected
                                  ? "0 4px 12px rgba(255, 140, 0, 0.4)"
                                  : "0 3px 10px rgba(79, 99, 103, 0.25)",
                              }}
                            >
                              <i
                                className={`mdi ${category.icon}`}
                                style={{
                                  fontSize: 24,
                                  color: "#fff",
                                }}
                              />
                            </div>
                            <h5
                              style={{
                                fontWeight: 700,
                                fontSize: "1rem",
                                marginBottom: 4,
                                color: isSelected ? "#e67e00" : "#4f6367",
                              }}
                            >
                              {category.label}
                            </h5>
                            <p
                              style={{
                                fontSize: "0.8rem",
                                color: "#6c757d",
                                marginBottom: 0,
                                lineHeight: 1.3,
                              }}
                            >
                              {category.description}
                            </p>
                          </div>
                        </div>
                        {/* Bottom section with vehicle image */}
                        <div
                          style={{
                            position: "relative",
                            height: "calc(100% - 130px)",
                            background: isSelected
                              ? "linear-gradient(180deg, #fff5e6 0%, #fffaf5 100%)"
                              : "linear-gradient(180deg, #f8f9fa 0%, #fff 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            paddingBottom: isSelected ? 30 : 0,
                          }}
                        >
                          <img
                            src={category.backgroundImage}
                            alt={category.label}
                            style={{
                              maxWidth: "85%",
                              maxHeight: "80px",
                              objectFit: "contain",
                              transition: "all 0.3s ease",
                              filter: isSelected ? "none" : "grayscale(20%)",
                            }}
                          />
                        </div>
                        {/* Selection indicator */}
                        {isSelected && (
                          <div
                            style={{
                              position: "absolute",
                              bottom: 10,
                              left: "50%",
                              transform: "translateX(-50%)",
                              background: "linear-gradient(135deg, #34D1BF, #0ae3ca)",
                              color: "#fff",
                              padding: "5px 14px",
                              borderRadius: 20,
                              fontSize: "0.75rem",
                              fontWeight: 600,
                              display: "flex",
                              alignItems: "center",
                              gap: 5,
                              boxShadow: "0 2px 8px rgba(52, 209, 191, 0.4)",
                              zIndex: 3,
                            }}
                          >
                            <i className="mdi mdi-check-circle" style={{ fontSize: 14 }} />
                            Selected
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </Col>
            </Row>

            {/* Filtered Vehicle Selection based on Wizard */}
            {this.state.selectedVehicleCategory && (
              <Row>
                <Col lg={12}>
                  <div className="d-flex align-items-center mb-3">
                    <h3 id="vehiclesizes" className="mb-0">
                      Select your specific vehicle
                    </h3>
                    <Button
                      color="link"
                      size="sm"
                      className="ml-3"
                      onClick={() => this.setState({ selectedVehicleCategory: null, truckType: "" })}
                    >
                      <i className="mdi mdi-arrow-left mr-1"></i>
                      Change category
                    </Button>
                  </div>
                  <div className="hero-wrapper mb-4">
                    <Row className="mb-5 landing-menu">
                      {/* Cargo vehicles filtered by wizard selection (tonnage-based) */}
                      {!this.vehicleCategories.find(c => c.id === this.state.selectedVehicleCategory)?.isPassenger &&
                        !this.vehicleCategories.find(c => c.id === this.state.selectedVehicleCategory)?.loadgroups &&
                        this.state.uniqueTonnages
                          ?.filter((tonnage) =>
                            this.vehicleCategories
                              .find((c) => c.id === this.state.selectedVehicleCategory)
                              ?.tonnageRange.includes(tonnage)
                          )
                          .map((tonnage) => (
                            <Col
                              key={tonnage}
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              xl={12}
                              className="vehicle-size-parent"
                            >
                              <h4>{tonnage} Ton</h4>
                              {vehicletypes
                                .filter((v) => v.display === true && v.tonnes === tonnage)
                                ?.map((vehicle) => {
                                  const image = `https://media.qiktruck.co.za/${vehicle.type}.png`;
                                  return (
                                    <div
                                      key={vehicle.type}
                                      className="vehicle-size"
                                      onClick={() =>
                                        this.setState(
                                          { truckType: vehicle.type },
                                          () => {
                                            window.document
                                              .getElementById("registrationform")
                                              .scrollIntoView();
                                          }
                                        )
                                      }
                                    >
                                      <div
                                        className={
                                          this.state.truckType === vehicle.type
                                            ? "selected-truck"
                                            : ""
                                        }
                                      ></div>
                                      <img
                                        src={image}
                                        alt={vehicle.displaytype}
                                        className={
                                          "menu-truck " +
                                          (this.state.truckType === vehicle.type
                                            ? "menu-truck-selected"
                                            : "")
                                        }
                                        height="20"
                                      />
                                      <i
                                        className={
                                          "mdi mdi-check-circle ml-2 " +
                                          (this.state.truckType === vehicle.type
                                            ? "checked-truck"
                                            : "hide")
                                        }
                                      ></i>
                                      <p className="menu-truck-type">{vehicle.displaytype}</p>
                                    </div>
                                  );
                                })}
                              <div className="vehicle-examples mb-4">
                                <b>Examples:</b>{" "}
                                {vehicletypes
                                  .filter((v) => v.display === true && v.tonnes === tonnage)
                                  ?.map((vehicle) =>
                                    vehicle.realWorldExamples
                                      ? vehicle.realWorldExamples.join(", ")
                                      : null
                                  )
                                  .filter(Boolean)
                                  .join(", ")}
                              </div>
                            </Col>
                          ))}

                      {/* Passenger vehicles when a passenger category is selected */}
                      {this.vehicleCategories.find(c => c.id === this.state.selectedVehicleCategory)?.isPassenger &&
                        this.state.nonCargoGroups
                          ?.filter((groupData) => {
                            const selectedCategory = this.vehicleCategories.find(
                              (c) => c.id === this.state.selectedVehicleCategory
                            );
                            // If loadgroups is defined, filter by it; otherwise show all
                            if (selectedCategory?.loadgroups && selectedCategory.loadgroups.length > 0) {
                              return selectedCategory.loadgroups.includes(groupData.group);
                            }
                            return true;
                          })
                          .map((groupData) => (
                          <Col
                            key={groupData.group}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            xl={12}
                            className="vehicle-size-parent"
                          >
                            <h4>{groupData.group}</h4>
                            {groupData.vehicles?.map((vehicle) => {
                              const image = `https://media.qiktruck.co.za/${vehicle.type}.png`;
                              return (
                                <div
                                  key={vehicle.type}
                                  className="vehicle-size"
                                  onClick={() =>
                                    this.setState(
                                      { truckType: vehicle.type },
                                      () => {
                                        window.document
                                          .getElementById("registrationform")
                                          .scrollIntoView();
                                      }
                                    )
                                  }
                                >
                                  <div
                                    className={
                                      this.state.truckType === vehicle.type
                                        ? "selected-truck"
                                        : ""
                                    }
                                  ></div>
                                  <img
                                    src={image}
                                    alt={vehicle.displaytype}
                                    className={
                                      "menu-truck " +
                                      (this.state.truckType === vehicle.type
                                        ? "menu-truck-selected"
                                        : "")
                                    }
                                    height="20"
                                  />
                                  <i
                                    className={
                                      "mdi mdi-check-circle ml-2 " +
                                      (this.state.truckType === vehicle.type
                                        ? "checked-truck"
                                        : "hide")
                                    }
                                  ></i>
                                  <p className="menu-truck-type">{vehicle.displaytype}</p>
                                </div>
                              );
                            })}
                            <div className="vehicle-examples mb-4">
                              <b>Examples:</b>{" "}
                              {groupData.vehicles
                                ?.map((vehicle) =>
                                  vehicle.realWorldExamples
                                    ? vehicle.realWorldExamples.join(", ")
                                    : null
                                )
                                .filter(Boolean)
                                .join(", ")}
                            </div>
                          </Col>
                        ))}

                      {/* Non-passenger vehicles filtered by loadgroup (e.g., Tow Trucks) */}
                      {!this.vehicleCategories.find(c => c.id === this.state.selectedVehicleCategory)?.isPassenger &&
                        this.vehicleCategories.find(c => c.id === this.state.selectedVehicleCategory)?.loadgroups &&
                        this.state.nonCargoGroups
                          ?.filter((groupData) => {
                            const selectedCategory = this.vehicleCategories.find(
                              (c) => c.id === this.state.selectedVehicleCategory
                            );
                            return selectedCategory?.loadgroups?.includes(groupData.group);
                          })
                          .map((groupData) => (
                          <Col
                            key={groupData.group}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            xl={12}
                            className="vehicle-size-parent"
                          >
                            <h4>{groupData.group}</h4>
                            {groupData.vehicles?.map((vehicle) => {
                              const image = `https://media.qiktruck.co.za/${vehicle.type}.png`;
                              return (
                                <div
                                  key={vehicle.type}
                                  className="vehicle-size"
                                  onClick={() =>
                                    this.setState(
                                      { truckType: vehicle.type },
                                      () => {
                                        window.document
                                          .getElementById("registrationform")
                                          .scrollIntoView();
                                      }
                                    )
                                  }
                                >
                                  <div
                                    className={
                                      this.state.truckType === vehicle.type
                                        ? "selected-truck"
                                        : ""
                                    }
                                  ></div>
                                  <img
                                    src={image}
                                    alt={vehicle.displaytype}
                                    className={
                                      "menu-truck " +
                                      (this.state.truckType === vehicle.type
                                        ? "menu-truck-selected"
                                        : "")
                                    }
                                    height="20"
                                  />
                                  <i
                                    className={
                                      "mdi mdi-check-circle ml-2 " +
                                      (this.state.truckType === vehicle.type
                                        ? "checked-truck"
                                        : "hide")
                                    }
                                  ></i>
                                  <p className="menu-truck-type">{vehicle.displaytype}</p>
                                </div>
                              );
                            })}
                            <div className="vehicle-examples mb-4">
                              <b>Examples:</b>{" "}
                              {groupData.vehicles
                                ?.map((vehicle) =>
                                  vehicle.realWorldExamples
                                    ? vehicle.realWorldExamples.join(", ")
                                    : null
                                )
                                .filter(Boolean)
                                .join(", ")}
                            </div>
                          </Col>
                        ))}

                      {/* Loading state */}
                      {(!this.state.uniqueTonnages || this.state.uniqueTonnages.length === 0) &&
                        !this.vehicleCategories.find(c => c.id === this.state.selectedVehicleCategory)?.isPassenger && (
                          <Col lg={12} className="mt-3 d-flex align-items-center">
                            <i className="mdi mdi-loading mdi-spin mr-2"></i>
                            <span>Loading available vehicles...</span>
                          </Col>
                        )}
                    </Row>
                  </div>
                </Col>
              </Row>
            )}

            {/* Show prompt if no category selected */}
            {!this.state.selectedVehicleCategory && (
              <Row>
                <Col lg={12} className="text-center py-5">
                  <i className="mdi mdi-hand-pointing-up text-muted" style={{ fontSize: 48 }}></i>
                  <h5 className="text-muted mt-3">Select a vehicle type above to see available options</h5>
                </Col>
              </Row>
            )}

            {/* Hidden legacy section - kept for backwards compatibility but not shown */}
            <div style={{ display: "none" }}>
            <Row>
              <h3 id={"vehiclesizes-legacy"}>Pick your vehicle size below</h3>
              <Col lg={12}>
                <div className="hero-wrapper mb-4">
                  <Row className="mb-5 landing-menu">
                    {this.state.uniqueTonnages?.length > 0 &&
                      this.state.uniqueTonnages?.map((tonnage) => {
                        return (
                          <Col
                            key={tonnage}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            xl={12}
                            className={"vehicle-size-parent"}
                          >
                            <h4>{tonnage} Ton</h4>
                            {vehicletypes
                              .filter(
                                (v) =>
                                  v.display === true && v.tonnes === tonnage
                              )
                              ?.map((vehicle) => {
                                const image = `https://media.qiktruck.co.za/${vehicle.type}.png`;
                                return (
                                  <div
                                    className={" vehicle-size"}
                                    onClick={() =>
                                      this.setState(
                                        {
                                          truckType: vehicle.type,
                                        },
                                        () => {
                                          window.document
                                            .getElementById("registrationform")
                                            .scrollIntoView();
                                        }
                                      )
                                    }
                                  >
                                    <div
                                      className={
                                        this.state.truckType === vehicle.type
                                          ? "selected-truck"
                                          : ""
                                      }
                                    ></div>
                                    <img
                                      src={image}
                                      alt={vehicle.displaytype}
                                      className={
                                        "menu-truck " +
                                        (this.state.truckType === vehicle.type
                                          ? "menu-truck-selected"
                                          : "")
                                      }
                                      height="20"
                                    />
                                    <i
                                      className={
                                        "mdi mdi-check-circle ml-2 " +
                                        (this.state.truckType === vehicle.type
                                          ? "checked-truck"
                                          : "hide")
                                      }
                                    ></i>
                                    <p className="menu-truck-type">
                                      {vehicle.displaytype}
                                    </p>
                                  </div>
                                );
                              })}
                            <div className="vehicle-examples mb-4">
                              <b>Examples:</b>{" "}
                              {vehicletypes
                                .filter(
                                  (v) =>
                                    v.display === true && v.tonnes === tonnage
                                )
                                ?.map((vehicle) => {
                                  return (
                                    vehicle.realWorldExamples && // if real world examples exist
                                    vehicle.realWorldExamples.join(", ") // join them
                                  );
                                })}
                            </div>
                          </Col>
                        );
                      })}

                    <Col
                      lg={4}
                      md={4}
                      sm={4}
                      xs={6}
                      xl={2}
                      className={"grey-border-bottom "}
                    ></Col>
                    {(!this.state.uniqueTonnages ||
                      this.state.uniqueTonnages.length === 0) && (
                      <Col lg={12} className={"mt-3 d-flex align-items-center"}>
                        <i className="mdi mdi-loading mdi-spin mr-2"></i>
                        <span>Loading available vehicle sizes...</span>
                      </Col>
                    )}
                  </Row>
                </div>
              </Col>
            </Row>
            </div>
            {/* End of hidden legacy section */}

            <p id={"registrationform"}></p>
            <h3>Let's create your profile</h3>
            <p>
              We use this information for criminal checks, vehicle theft
              reports, fraud checks and other means to secure customer property.
              <br />
            </p>
            <br/>
<p>
              Do not register a vehicle if you do not have permission to use it for
              transporting goods. QikTruck will verify vehicle ownership and
              registration during the application process.
            </p>
            <hr />
            <Row>
              <Col lg={6} sm={6}>
                <FormGroup>
                  <Label for="firstname">
                    Owner Firstname{" "}
                    <span style={{ color: "green" }}>*</span>
                  </Label>
                  <Input
                    id="firstname"
                    name="firstname"
                    type="text"
                    onChange={(e) => {
                      this.setState({ firstname: e.target.value });
                    }}
                  />
                </FormGroup>
              </Col>
              <Col lg={6} sm={6}>
                <FormGroup>
                  <Label for="lastname">
                   Owner Surname <span style={{ color: "green" }}>*</span>
                  </Label>
                  <Input
                    id="lastname"
                    name="lastname"
                    type="text"
                    onChange={(e) => {
                      this.setState({ lastname: e.target.value });
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg={6} sm={6}>
                <FormGroup>
                  <Label for="email">
                    Email <span style={{ color: "green" }}>*</span>
                  </Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    onChange={(e) => {
                      this.setState({ email: e.target.value });
                    }}
                  />
                </FormGroup>
              </Col>
              <Col lg={6} sm={6}>
                <FormGroup>
                  <Label for="mobilenumber">
                    Mobile number <span style={{ color: "green" }}>*</span>
                  </Label>
                  <Input
                    id="mobilenumber"
                    name="mobilenumber"
                    type="tel"
                    onChange={(e) => {
                      this.setState({ mobilenumber: e.target.value });
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg={6} sm={6}>
                <FormGroup>
                  <Label for="idnumber">
                    ID/Passport number{" "}
                    <span style={{ color: "green" }}>*</span>
                  </Label>
                  <Input
                    id="idnumber"
                    name="idnumber"
                    onChange={(e) => {
                      this.setState({ idnumber: e.target.value });
                    }}
                  />
                </FormGroup>
              </Col>
              <Col lg={6} sm={6}>
                {/* <FormGroup>
                  <Label for="vin">
                    Vehicle VIN <span style={{ color: "green" }}>*</span>
                  </Label>
                  <Input
                    id="vin"
                    name="vin"
                    onChange={(e) => {
                      this.setState({ vin: e.target.value });
                    }}
                  />
                </FormGroup> */}
                <FormGroup>
                  <Label for="licenseplatenumber">
                    Vehicle License Plate Number{" "}
                    <span style={{ color: "green" }}>*</span>
                  </Label>
                  <Input
                    id="licenseplatenumber"
                    name="licenseplatenumber"
                    onChange={(e) => {
                      this.setState({ licenseplatenumber: e.target.value });
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg={6} sm={6}>
                <FormGroup className="mb-4">
                  <Label className="font-15">
                    Vehicle Location <span style={{ color: "green" }}>*</span>
                  </Label>
                  <PlacesAutocomplete
                    type="text"
                    className="form-control"
                    id="location"
                    placeholder="enter street address"
                    required
                    onPlaceSelected={(place) => {
                      if (!place?.geometry?.location?.lat()) {
                        Bugsnag.notify(
                          new Error(
                            "V REGISTRATION place not found: " +
                              this.state.email
                          )
                        );
                      }
                      this.setState({
                        location: {
                          lat: place?.geometry?.location?.lat(),
                          lng: place?.geometry?.location?.lng(),
                        },
                      });
                    }}
                  />
                  {this.state.location.lat === 0 ||
                  this.state.location.lat === 0 ? (
                    <small className="red">Select your vehicle location</small>
                  ) : (
                    <p>Location set</p>
                  )}
                </FormGroup>
              </Col>
            </Row>

            {this.state.loading === false && this.state.apierror.length > 0 && (
              <p className="error-message">{this.state.apierror}</p>
            )}

            {/* Selected Vehicle Card */}
            <div className={`card shadow selected-vehicle-card mb-4 ${this.state.truckType ? 'has-vehicle' : ''}`}>
              <div className="card-body">
                <div className="card-header-title">
                  <i className="mdi mdi-truck-check"></i>
                  SELECTED VEHICLE
                </div>
                
                {this.state.truckType?.length > 0 ? (
                  <Row className="align-items-center">
                    <Col md={4} className="text-center mb-3 mb-md-0">
                      <div
                        className="vehicle-image-wrapper"
                        onClick={() =>
                          window.document
                            .getElementById("vehiclepicker")
                            .scrollIntoView({ behavior: 'smooth' })
                        }
                      >
                        <img
                          src={`https://media.qiktruck.co.za/${this.state.truckType}.png`}
                          alt={this.state.truckType}
                        />
                        <div className="change-vehicle-link">
                          <i className="mdi mdi-pencil"></i>
                          Change vehicle
                        </div>
                      </div>
                    </Col>
                    <Col md={8}>
                      {(() => {
                        const selectedVehicle = this.state.vehicletypes?.find(v => v.type === this.state.truckType) ||
                          this.state.nonCargoGroups?.flatMap(g => g.vehicles)?.find(v => v.type === this.state.truckType);
                        return selectedVehicle ? (
                          <div className="vehicle-details">
                            <h5>{selectedVehicle.displaytype}</h5>
                            <div className="specs-grid">
                              {selectedVehicle.tonnes > 0 && (
                                <div className="spec-item">
                                  <small>Capacity</small>
                                  <p>{selectedVehicle.tonnes} Ton</p>
                                </div>
                              )}
                              <div className="spec-item">
                                <small>Category</small>
                                <p>{selectedVehicle.loadgroup}</p>
                              </div>
                              <div className="spec-item">
                                <small>Body Type</small>
                                <p>{selectedVehicle.bodylabel}</p>
                              </div>
                            </div>
                            {selectedVehicle.tip?.examples && (
                              <div className="ideal-for">
                                <i className="mdi mdi-lightbulb-on-outline"></i>
                                <b>Ideal for:</b> {selectedVehicle.tip.examples}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="vehicle-details">
                            <h5>{this.state.truckType}</h5>
                          </div>
                        );
                      })()}
                    </Col>
                  </Row>
                ) : (
                  <div
                    className="no-vehicle-selected"
                    onClick={() =>
                      window.document
                        .getElementById("vehiclepicker")
                        .scrollIntoView({ behavior: 'smooth' })
                    }
                  >
                    <i className="mdi mdi-truck-outline"></i>
                    <p className="mb-0">
                      <i className="mdi mdi-alert-circle"></i>
                      Please select a vehicle above
                    </p>
                  </div>
                )}

                <hr className="divider" />

                {/* Agreement Checkboxes */}
                <div className="agreement-section">
                  <div 
                    className={`agreement-item ${this.state.agreeToPartner ? 'checked' : ''}`}
                    onClick={() => this.setState({ agreeToPartner: !this.state.agreeToPartner })}
                  >
                    <div className="checkbox-custom"></div>
                    <div className="agreement-content">
                      <div className="agreement-title">I agree to become a QikTruck Driver Partner</div>
                      <div className="agreement-description">
                        I will make my vehicle available for on-demand trips and agree to the 
                        <a href="/terms" target="_blank" onClick={(e) => e.stopPropagation()}> terms and conditions</a>.
                      </div>
                    </div>
                    <input
                      type="checkbox"
                      checked={this.state.agreeToPartner}
                      onChange={() => {}}
                    />
                  </div>
                  <div 
                    className={`agreement-item ${this.state.agreeToNotifications ? 'checked' : ''}`}
                    onClick={() => this.setState({ agreeToNotifications: !this.state.agreeToNotifications })}
                  >
                    <div className="checkbox-custom"></div>
                    <div className="agreement-content">
                      <div className="agreement-title">Receive notifications about QikTruck services</div>
                      <div className="agreement-description">
                        Get updates about new trips, promotions, and QikTruck news via SMS and email.
                      </div>
                    </div>
                    <input
                      type="checkbox"
                      checked={this.state.agreeToNotifications}
                      onChange={() => {}}
                    />
                  </div>
                </div>

                {/* Register Button */}
                <Button
                  className="btn-block register-btn mt-4"
                  size="lg"
                  onClick={() => this.registerVehicle()}
                  disabled={!this.validStepOne() || this.state.loading || !this.state.agreeToPartner}
                >
                  {this.state.loading ? (
                    <>
                      <i className="mdi mdi-loading mdi-spin mr-2"></i>
                      Registering...
                    </>
                  ) : (
                    <>
                      Register Vehicle
                      <i className="mdi mdi-arrow-right"></i>
                    </>
                  )}
                </Button>
                {!this.state.agreeToPartner && (
                  <div className="terms-reminder">
                    <i className="mdi mdi-information-outline"></i>
                    Please agree to the driver partner terms to continue
                  </div>
                )}
              </div>
            </div>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
